import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MultiEntitySelectionReportParameter } from '@ndt/report-output/shared/models/multi-entity-selection-report-parameter';
import { SelectedAccountReportParameter } from '@ndt/report-output/shared/models/selected-account-report-parameter';
import {
   ParameterFormValueUnion,
   convertFromFormValueList,
} from '@ndt/reports/shared/report-parameter-list/models/report-parameter-form-value';
import {
   ReportParametersUnion,
   convertToForm,
} from '@ndt/reports/shared/report-parameter-list/models/report-parameter-union.model';
import { ReportParameterConfig } from '@ndt/reports/shared/report-parameter-list/report-parameter.config';
import {
   ReportParameterFormService,
   ReportParameterFormServiceBase,
} from '@ndt/reports/shared/report-parameter-list/services/report-parameter-form.service';
import { ReportParameters } from 'generated/graphql-types';
import { LcsDateTimeAdapter } from 'src/app/common-components/date-time-picker/configuration/date-time-adapter';

export class PhoneQueuesParametersFormService
   extends ReportParameterFormServiceBase
   implements ReportParameterFormService<any>
{
   config: ReportParameterConfig[];

   form: UntypedFormGroup;

   accountId: number | null = null;

   constructor(fb: UntypedFormBuilder, _dateAdapter: LcsDateTimeAdapter<Date>) {
      super(fb);

      const initialValue: ReportParametersUnion[] = [
         {
            parameterType: ReportParameters.SelectedAccount,
            sortOrder: 1,
            value: null,
            name: null,
         },
         {
            parameterType: ReportParameters.CallQueueExtensionsToInclude,
            sortOrder: 2,
            values: [],
            names: [''],
         },
      ];

      this.config = [
         {
            label: 'Selected Account',
            type: 'selectedAccount',
         },
         {
            label: 'Queues to Include',
            type: 'callQueueExtensions',
         },
      ];

      this.form = convertToForm(initialValue, fb);
   }

   convertValue(values: ReportParametersUnion[]): any | null {
      const selectedAccount = values.find((v) => {
         return v.parameterType === ReportParameters.SelectedAccount;
      }) as SelectedAccountReportParameter | undefined;

      const extensions = values.find((v) => {
         return v.parameterType === ReportParameters.CallQueueExtensionsToInclude;
      }) as MultiEntitySelectionReportParameter | undefined;

      const output: any = {
         selectedAccount,
         callQueueExtensions: extensions,
         tileLayoutConfiguration: this.getLayoutConfigurations(values),
      };
      return output;
   }

   getValue(): any | null {
      const formValue = this.form.getRawValue();
      const values: ParameterFormValueUnion[] = this.convertPhoneQueuesAccountValue(formValue.values);
      const convertedValues = convertFromFormValueList(values);
      return this.convertValue(convertedValues);
   }

   isListComplete(values: ReportParametersUnion[], _includeAskParameter = false): boolean {
      const selectedAccount = values.find((v) => {
         return v.parameterType === ReportParameters.SelectedAccount;
      });

      const extensions = values.find((v) => {
         return v.parameterType === ReportParameters.CallQueueExtensionsToInclude;
      });

      return !!selectedAccount && !!extensions;
   }

   orderValues(): void {
      const { values } = this.form.value;
      this.form.setValue({ values: [...values] });
   }

   patchSavedValues(values: ReportParametersUnion[]): void {
      super.patchSavedValues(values, false, false);
   }

   setValue(values: ParameterFormValueUnion[]): void {
      this.form.setValue(values);
   }

   private convertPhoneQueuesAccountValue(values): ParameterFormValueUnion[] {
      return values.map((v) => {
         if (v.parameterType === ReportParameters.SelectedAccount) {
            if (v.value && v.value.accountId !== undefined) {
               this.accountId = v.value.accountId;
               return { ...v, value: v.value.accountId, name: v.value.name || 0 };
            } else {
               return { ...v, value: v.value || 0 };
            }
         }
         return v;
      });
   }
}
